import * as React from 'react'
import useSustainabilityStore from '@/features/Sustainability/stores/useSustainabilityStore/useSustainabilityStore'
import { DrawerWrapper } from '@/components'
import { useEffect, useState } from 'react'
import { useElementWidth, useFiltersStore } from '@/hooks'
import { TotalEmissionsActions } from './TotalEmissionsActions/TotalEmissionsActions'
import { useSustainabilityHeaderSlot } from '../SustainabilityHeaderSlot/useSustainabilityHeaderSlot'
import { TotalEmissionsReport } from './TotalEmissionsReport'
import { useSustainabilityFiltersStore } from '../../hooks/useSustainabilityFiltersStore'
import { mapFiltersToParams } from '@/features/Reporting/components/ReportEdit/mapFiltersToParams'
import { TotalEmissionsDrawer } from '../TotalEmissionsDrawer/TotalEmissionsDrawer'
import { useSustainabilityFiltersGetParams } from '../../hooks/useSustainabilityFiltersGetParams'
import { useScope2TypeAvailability } from '../../hooks/useScope2TypeAvailability'
import { useFeatureFlag } from '@/components/providers/FeatureFlagsProvider/useFeatureFlag'

export const TotalEmissions: React.FC = () => {
    const { setSlot } = useSustainabilityHeaderSlot()
    const [isOpen, setIsOpen] = useState(false)
    const toggleButtonRef = React.useRef<HTMLButtonElement>(null)
    const toggleWidth = useElementWidth(toggleButtonRef)

    const isDataManagementEnabled = useFeatureFlag('dataManagement')

    const activeFilters = useSustainabilityFiltersStore(
        (state) => state.activeFilters
    )
    const rootNode = useFiltersStore((state) => state.rootNode)

    const filterParams = mapFiltersToParams(activeFilters)

    if (filterParams.nodeIds.length === 0 && rootNode?.nodeId !== undefined) {
        filterParams.nodeIds = [rootNode.nodeId]
    }

    const reportSettings = useSustainabilityStore(
        (state) => state.totalEmissions.reportSettings
    )

    const setReportSettings = useSustainabilityStore(
        (state) => state.totalEmissions.setReportSettings
    )

    const { isMarketBasedScope2Available, isFetched } =
        useScope2TypeAvailability({
            reportSettings,
            setReportSettings,
        })

    const view = useSustainabilityStore(
        (state) => state.totalEmissions.selectedView
    )

    const setView = useSustainabilityStore(
        (state) => state.totalEmissions.setSelectedView
    )

    const calculationMethodOffset = isOpen ? 16 : toggleWidth

    const processedFilters = useSustainabilityFiltersGetParams(
        activeFilters,
        reportSettings
    )

    useEffect(() => {
        setSlot(<TotalEmissionsActions filters={processedFilters} />)
        return () => {
            setSlot(null)
        }
    }, [processedFilters, setSlot])

    return (
        <DrawerWrapper>
            <TotalEmissionsDrawer
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                toggleButtonRef={toggleButtonRef}
                reportSettings={reportSettings}
                setReportSettings={setReportSettings}
                filters={processedFilters}
                isMarketBasedScope2Available={isMarketBasedScope2Available}
                isDataReady={!isDataManagementEnabled || isFetched}
            />
            <TotalEmissionsReport
                filters={activeFilters}
                reportSettings={reportSettings}
                isOpen={isOpen}
                calculationMethodOffset={calculationMethodOffset}
                view={view}
                setView={setView}
            />
        </DrawerWrapper>
    )
}
